"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaffoldQuestionForVS = exports.VSCapabilityOptions = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../common/localizeUtils");
const templateNames_1 = require("../../../component/generator/templates/templateNames");
const create_1 = require("../../create");
const questionNames_1 = require("../../questionNames");
const agentForTeamsNode_1 = require("../vsc/agentForTeamsNode");
const CapabilityOptions_1 = require("../vsc/CapabilityOptions");
const createRootNode_1 = require("../vsc/createRootNode");
const daProjectTypeNode_1 = require("../vsc/daProjectTypeNode");
const teamsProjectTypeNode_1 = require("../vsc/teamsProjectTypeNode");
class VSCapabilityOptions {
    // empty
    static empty() {
        return {
            id: "empty",
            label: "Empty",
            data: templateNames_1.TemplateNames.Empty,
        };
    }
    static declarativeAgent() {
        return {
            id: "declarative-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.detail"),
        };
    }
    static nonSsoTab() {
        return {
            id: "tab-non-sso",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.TabNonSso.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabNonSso.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.TabSSR,
        };
    }
    static tab() {
        return {
            id: "tab",
            label: (0, localizeUtils_1.getLocalizedString)("core.TabOption.label"),
            description: (0, localizeUtils_1.getLocalizedString)("core.TabOption.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabOption.detail"),
            data: templateNames_1.TemplateNames.SsoTabSSR,
        };
    }
    static aiAssistantBot() {
        return {
            id: "ai-assistant-bot",
            label: (0, localizeUtils_1.getLocalizedString)("core.aiAssistantBotOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.aiAssistantBotOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.AIAssistantBot,
        };
    }
    static SearchMeVS() {
        return {
            id: "search-message-extension",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.M365SearchAppOptionItem.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.SearchAppOptionItem.detail"),
            data: templateNames_1.TemplateNames.MessageExtensionSearch,
        };
    }
    // Currently only for dotnet
    static weatherAgentBot() {
        return {
            id: "custom-copilot-weather-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotWeatherOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotWeatherOption.detail"),
            data: templateNames_1.TemplateNames.WeatherAgent,
        };
    }
}
exports.VSCapabilityOptions = VSCapabilityOptions;
/**
 * Scaffold question model dedicated for VS platform
 */
function scaffoldQuestionForVS() {
    const node = {
        data: { type: "group" },
        children: [
            {
                data: {
                    name: questionNames_1.QuestionNames.Capabilities,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.titleNew"),
                    type: "singleSelect",
                    staticOptions: [
                        VSCapabilityOptions.empty(),
                        VSCapabilityOptions.declarativeAgent(),
                        CapabilityOptions_1.CustomCopilotCapabilityOptions.basicChatbot(),
                        CapabilityOptions_1.CustomCopilotCapabilityOptions.customCopilotRag(),
                        CapabilityOptions_1.CustomCopilotCapabilityOptions.aiAgent(),
                        VSCapabilityOptions.weatherAgentBot(),
                        CapabilityOptions_1.BotCapabilityOptions.basicBot(),
                        CapabilityOptions_1.BotCapabilityOptions.aiBot(),
                        VSCapabilityOptions.aiAssistantBot(),
                        CapabilityOptions_1.BotCapabilityOptions.notificationBot(),
                        CapabilityOptions_1.BotCapabilityOptions.commandBot(),
                        CapabilityOptions_1.BotCapabilityOptions.workflowBot(),
                        VSCapabilityOptions.nonSsoTab(),
                        VSCapabilityOptions.tab(),
                        CapabilityOptions_1.MeCapabilityOptions.m365SearchMe(),
                        CapabilityOptions_1.MeCapabilityOptions.collectFormMe(),
                        VSCapabilityOptions.SearchMeVS(),
                        CapabilityOptions_1.MeCapabilityOptions.linkUnfurling(),
                        CapabilityOptions_1.TdpCapabilityOptions.me(),
                    ],
                    onDidSelection: CapabilityOptions_1.setTemplateName,
                },
                children: [
                    (0, daProjectTypeNode_1.daProjectTypeNode)(VSCapabilityOptions.declarativeAgent().id),
                    (0, agentForTeamsNode_1.customCopilotRagNode)(),
                    (0, agentForTeamsNode_1.aiAgentNode)(),
                    (0, teamsProjectTypeNode_1.m365SearchMeSubNode)(),
                    (0, agentForTeamsNode_1.llmServiceNode)({
                        enum: [
                            CapabilityOptions_1.CustomCopilotCapabilityOptions.basicChatbot().id,
                            CapabilityOptions_1.CustomCopilotCapabilityOptions.customCopilotRag().id,
                            CapabilityOptions_1.CustomCopilotCapabilityOptions.aiAgent().id,
                            VSCapabilityOptions.weatherAgentBot().id,
                        ],
                    }),
                    (0, teamsProjectTypeNode_1.notificationBotTriggerNode)(teamsfx_api_1.Platform.VS),
                ],
            },
            (0, createRootNode_1.languageNode)(),
            {
                condition: createRootNode_1.folderAndAppNameCondition,
                data: {
                    type: "group",
                },
                children: [
                    {
                        data: (0, create_1.folderQuestion)(),
                    },
                    {
                        data: (0, create_1.appNameQuestion)(),
                    },
                ],
            },
        ],
    };
    return node;
}
exports.scaffoldQuestionForVS = scaffoldQuestionForVS;
//# sourceMappingURL=createRootNode.js.map